import type { FC, ReactElement } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../types';

import { type BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const VideoStreamQualityConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        dispatch(popupActions.dismissPopup(PopupType.VideoStreamQuality));
      },
    },
  ] as BlockingModalActionButton[];

  return <BlockingModalContent messageTk="LOW_BANDWIDTH" actions={action} />;
};
